"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  id: "",
  firstName: "",
  lastName: "",
  address: "",
  phoneNumber: "",
  isSearch: false,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer(state, action) {
      const { firstName, lastName, address, phoneNumber, id } = action.payload;
      state.id = id;
      state.firstName = firstName;
      state.lastName = lastName;
      state.address = address;
      state.phoneNumber = phoneNumber;
    },
    setIsSearch(state, action) {
      state.isSearch = action.payload;
    },

    resetCustomerState(state, action) {
      return initialState;
    },
  },
});

export const { setCustomer, setIsSearch, resetCustomerState } =
  customerSlice.actions;

export default customerSlice.reducer;
